import { render, staticRenderFns } from "./inventorysettings.vue?vue&type=template&id=0638e742&scoped=true"
import script from "./inventorysettings.vue?vue&type=script&lang=js"
export * from "./inventorysettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0638e742",
  null
  
)

export default component.exports